var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-gap" },
    [
      _c(
        "div",
        { staticClass: "viq-gap__header" },
        [
          _c("h3", { staticClass: "viq-gap__title" }, [_vm._v("Gap Analysis")]),
          _vm._v(" "),
          _vm.step === "form"
            ? _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.goBack } },
                [_vm._v("Back")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.step === "form"
        ? _c(
            "div",
            { staticClass: "viq-gap__form" },
            [
              _c("p", { staticClass: "viq-gap__desc" }, [
                _vm._v(
                  "\n      Identify compliance gaps by answering guided questions about your current state.\n      VIQ will analyse your responses and provide severity ratings with remediation recommendations.\n    "
                ),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder:
                    "e.g., AML compliance for e-money institutions in the UK...",
                },
                model: {
                  value: _vm.topic,
                  callback: function ($$v) {
                    _vm.topic = $$v
                  },
                  expression: "topic",
                },
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "viq-gap__form-field",
                attrs: { size: "small", placeholder: "Jurisdiction" },
                model: {
                  value: _vm.jurisdiction,
                  callback: function ($$v) {
                    _vm.jurisdiction = $$v
                  },
                  expression: "jurisdiction",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viq-gap__form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.topic.trim() },
                      on: { click: _vm.startQuestions },
                    },
                    [_vm._v("\n        Start Assessment\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.step === "questions"
        ? _c("ViqGapQuestions", {
            attrs: { questions: _vm.gapQuestions },
            on: { submit: _vm.submitAnswers },
          })
        : _vm.step === "results"
        ? _c("ViqGapResults", { attrs: { results: _vm.gapResults } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }